import React from "react";

const HockeyMatchDetails = ({ matches, userNames, styles }) => {
  // Helper function to determine user's team and result
  const getUserResult = (match) => {
    const userId = localStorage.getItem("userId");
    if (!userId) return { userTeam: null, result: "UNKNOWN" };

    // Check if user is in team1
    const isInTeam1 =
      match.team1Players &&
      match.team1Players.some(
        (player) =>
          player.userId && player.userId.toString() === userId.toString()
      );

    // Check if user is in team2
    const isInTeam2 =
      match.team2Players &&
      match.team2Players.some(
        (player) =>
          player.userId && player.userId.toString() === userId.toString()
      );

    if (isInTeam1) {
      if (match.winner === "team1") return { userTeam: "team1", result: "WIN" };
      else if (match.winner === "team2")
        return { userTeam: "team1", result: "LOSS" };
      else return { userTeam: "team1", result: "TIE" };
    } else if (isInTeam2) {
      if (match.winner === "team2") return { userTeam: "team2", result: "WIN" };
      else if (match.winner === "team1")
        return { userTeam: "team2", result: "LOSS" };
      else return { userTeam: "team2", result: "TIE" };
    }

    return { userTeam: null, result: "SPECTATOR" };
  };

  return matches.map((match, matchIndex) => {
    const userResult = getUserResult(match);

    return (
      <div key={matchIndex} style={{ marginBottom: "clamp(18px, 4vw, 25px)" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "clamp(15px, 4vw, 20px)",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <h4
            style={{
              color: "#2c3e50",
              margin: 0,
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            Match #{matchIndex + 1}
          </h4>
          <span
            style={{
              backgroundColor:
                userResult.result === "WIN"
                  ? "#27ae60"
                  : userResult.result === "LOSS"
                  ? "#e74c3c"
                  : userResult.result === "TIE"
                  ? "#95a5a6"
                  : "#6c757d",
              color: "white",
              padding: "clamp(3px, 1vw, 4px) clamp(10px, 2.5vw, 12px)",
              borderRadius: "20px",
              fontSize: "clamp(11px, 2.2vw, 12px)",
              fontWeight: "600",
            }}
          >
            {userResult.result}
          </span>
        </div>

        {/* Team Names & Score */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#f8f9fa",
            padding: "clamp(15px, 4vw, 20px)",
            borderRadius: "12px",
            marginBottom: "clamp(15px, 4vw, 20px)",
            border: "2px solid #e9ecef",
            flexWrap: "wrap",
            gap: "15px",
          }}
        >
          <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
            <h3
              style={{
                color: "#2c3e50",
                margin: "0 0 clamp(8px, 2vw, 10px) 0",
                fontSize: "clamp(16px, 3.5vw, 20px)",
              }}
            >
              {match.team1Name || "Team 1"}
            </h3>
            <div
              style={{
                fontSize: "clamp(28px, 7vw, 36px)",
                fontWeight: "bold",
                color: "#27ae60",
              }}
            >
              {match.finalScore?.team1 || 0}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "clamp(18px, 4.5vw, 24px)",
              fontWeight: "bold",
              color: "#6c757d",
              minWidth: "60px",
              justifyContent: "center",
            }}
          >
            VS
          </div>
          <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
            <h3
              style={{
                color: "#2c3e50",
                margin: "0 0 clamp(8px, 2vw, 10px) 0",
                fontSize: "clamp(16px, 3.5vw, 20px)",
              }}
            >
              {match.team2Name || "Team 2"}
            </h3>
            <div
              style={{
                fontSize: "clamp(28px, 7vw, 36px)",
                fontWeight: "bold",
                color: "#e74c3c",
              }}
            >
              {match.finalScore?.team2 || 0}
            </div>
          </div>
        </div>

        {/* Match Info */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            gap: "clamp(12px, 3vw, 15px)",
            marginBottom: "clamp(15px, 4vw, 20px)",
            fontSize: "clamp(13px, 2.5vw, 15px)",
          }}
        >
          <p>
            <strong>Match Type:</strong> {match.matchType || "Regulation"}
          </p>
          <p>
            <strong>Period Length:</strong> {match.periodLength || 20} minutes
          </p>
          <p>
            <strong>Total Players:</strong>{" "}
            {(match.team1Players?.length || 0) +
              (match.team2Players?.length || 0)}
          </p>
        </div>

        {/* Period Scores */}
        {match.periods && match.periods.length > 0 && (
          <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
            <h4
              style={{
                color: "#2c3e50",
                marginBottom: "clamp(12px, 3vw, 15px)",
                fontSize: "clamp(15px, 3vw, 18px)",
              }}
            >
              🏒 Period by Period
            </h4>
            <table style={styles.setsTable}>
              <thead>
                <tr>
                  <th style={styles.tableTh}>Period</th>
                  <th style={styles.tableTh}>{match.team1Name || "Team 1"}</th>
                  <th style={styles.tableTh}>{match.team2Name || "Team 2"}</th>
                </tr>
              </thead>
              <tbody>
                {match.periods.map((period, index) => (
                  <tr key={index}>
                    <td style={styles.tableTd}>Period {period.number}</td>
                    <td style={styles.tableTd}>{period.team1Goals}</td>
                    <td style={styles.tableTd}>{period.team2Goals}</td>
                  </tr>
                ))}
                {/* Overtime */}
                {match.overtime &&
                  (match.overtime.team1Goals > 0 ||
                    match.overtime.team2Goals > 0) && (
                    <tr style={{ backgroundColor: "#fff3cd" }}>
                      <td style={styles.tableTd}>Overtime</td>
                      <td style={styles.tableTd}>
                        {match.overtime.team1Goals}
                      </td>
                      <td style={styles.tableTd}>
                        {match.overtime.team2Goals}
                      </td>
                    </tr>
                  )}
                {/* Shootout */}
                {match.shootout &&
                  (match.shootout.team1Goals > 0 ||
                    match.shootout.team2Goals > 0) && (
                    <tr style={{ backgroundColor: "#f8d7da" }}>
                      <td style={styles.tableTd}>Shootout</td>
                      <td style={styles.tableTd}>
                        {match.shootout.team1Goals}
                      </td>
                      <td style={styles.tableTd}>
                        {match.shootout.team2Goals}
                      </td>
                    </tr>
                  )}
                <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                  <td style={styles.tableTd}>Final</td>
                  <td style={styles.tableTd}>{match.finalScore?.team1 || 0}</td>
                  <td style={styles.tableTd}>{match.finalScore?.team2 || 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {/* Goal Events */}
        {match.goalEvents && match.goalEvents.length > 0 && (
          <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
            <h4
              style={{
                color: "#2c3e50",
                marginBottom: "clamp(12px, 3vw, 15px)",
                fontSize: "clamp(15px, 3vw, 18px)",
              }}
            >
              🥅 Goal Events
            </h4>
            <table style={styles.setsTable}>
              <thead>
                <tr>
                  <th style={styles.tableTh}>Period</th>
                  <th style={styles.tableTh}>Time</th>
                  <th style={styles.tableTh}>Team</th>
                  <th style={styles.tableTh}>Scorer</th>
                  <th style={styles.tableTh}>Assist</th>
                  <th style={styles.tableTh}>Type</th>
                </tr>
              </thead>
              <tbody>
                {match.goalEvents.map((goal, index) => (
                  <tr key={index}>
                    <td style={styles.tableTd}>P{goal.period}</td>
                    <td style={styles.tableTd}>{goal.time}</td>
                    <td style={styles.tableTd}>
                      {goal.team === "team1"
                        ? match.team1Name
                        : match.team2Name}
                    </td>
                    <td style={styles.tableTd}>
                      {goal.scorerId && userNames[goal.scorerId]
                        ? userNames[goal.scorerId]
                        : goal.scorer}
                    </td>
                    <td style={styles.tableTd}>
                      {goal.assistId && userNames[goal.assistId]
                        ? userNames[goal.assistId]
                        : goal.assist || "—"}
                    </td>
                    <td style={styles.tableTd}>
                      <span
                        style={{
                          backgroundColor:
                            goal.type === "powerplay"
                              ? "#28a745"
                              : goal.type === "shorthanded"
                              ? "#dc3545"
                              : goal.type === "penalty-shot"
                              ? "#ffc107"
                              : "#17a2b8",
                          color: "white",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {goal.type?.toUpperCase() || "EVEN"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Penalty Events */}
        {match.penaltyEvents && match.penaltyEvents.length > 0 && (
          <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
            <h4
              style={{
                color: "#2c3e50",
                marginBottom: "clamp(12px, 3vw, 15px)",
                fontSize: "clamp(15px, 3vw, 18px)",
              }}
            >
              ⚡ Penalties
            </h4>
            <table style={styles.setsTable}>
              <thead>
                <tr>
                  <th style={styles.tableTh}>Period</th>
                  <th style={styles.tableTh}>Time</th>
                  <th style={styles.tableTh}>Team</th>
                  <th style={styles.tableTh}>Player</th>
                  <th style={styles.tableTh}>Infraction</th>
                  <th style={styles.tableTh}>Minutes</th>
                </tr>
              </thead>
              <tbody>
                {match.penaltyEvents.map((penalty, index) => (
                  <tr key={index}>
                    <td style={styles.tableTd}>P{penalty.period}</td>
                    <td style={styles.tableTd}>{penalty.time}</td>
                    <td style={styles.tableTd}>
                      {penalty.team === "team1"
                        ? match.team1Name
                        : match.team2Name}
                    </td>
                    <td style={styles.tableTd}>
                      {penalty.playerId && userNames[penalty.playerId]
                        ? userNames[penalty.playerId]
                        : penalty.player}
                    </td>
                    <td style={styles.tableTd}>{penalty.infraction}</td>
                    <td style={styles.tableTd}>
                      <span
                        style={{
                          backgroundColor:
                            penalty.minutes >= 5
                              ? "#dc3545"
                              : penalty.minutes === 2
                              ? "#ffc107"
                              : "#28a745",
                          color: "white",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {penalty.minutes}min
                      </span>
                      {penalty.isGameMisconduct && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "10px",
                            marginLeft: "5px",
                          }}
                        >
                          (Game Misconduct)
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Team Rosters with Positions */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "clamp(12px, 4vw, 20px)",
          }}
        >
          <div>
            <h4
              style={{
                color: "#2c3e50",
                marginBottom: "clamp(8px, 2vw, 10px)",
                fontSize: "clamp(15px, 3vw, 18px)",
              }}
            >
              👥 {match.team1Name || "Team 1"}
            </h4>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "clamp(12px, 3vw, 15px)",
                borderRadius: "8px",
              }}
            >
              {match.team1Players && match.team1Players.length > 0 ? (
                match.team1Players.map((player, index) => {
                  const playerName = player.userId
                    ? userNames[player.userId] || player.name
                    : player.name;
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "8px 0",
                        borderBottom: "1px solid #dee2e6",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        {playerName}
                        {player.isCustom && (
                          <span
                            style={{
                              color: "#6c757d",
                              fontSize: "12px",
                              marginLeft: "5px",
                            }}
                          >
                            (Custom)
                          </span>
                        )}
                      </span>
                      <span
                        style={{
                          fontSize: "12px",
                          color:
                            player.position === "goalie"
                              ? "#dc3545"
                              : "#6c757d",
                          fontWeight:
                            player.position === "goalie" ? "bold" : "normal",
                        }}
                      >
                        {player.position?.charAt(0).toUpperCase() +
                          player.position?.slice(1) || "Forward"}
                      </span>
                    </div>
                  );
                })
              ) : (
                <div style={{ color: "#6c757d", fontStyle: "italic" }}>
                  No players added
                </div>
              )}
            </div>
          </div>
          <div>
            <h4 style={{ color: "#2c3e50", marginBottom: "10px" }}>
              👥 {match.team2Name || "Team 2"}
            </h4>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "15px",
                borderRadius: "8px",
              }}
            >
              {match.team2Players && match.team2Players.length > 0 ? (
                match.team2Players.map((player, index) => {
                  const playerName = player.userId
                    ? userNames[player.userId] || player.name
                    : player.name;
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "8px 0",
                        borderBottom: "1px solid #dee2e6",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        {playerName}
                        {player.isCustom && (
                          <span
                            style={{
                              color: "#6c757d",
                              fontSize: "12px",
                              marginLeft: "5px",
                            }}
                          >
                            (Custom)
                          </span>
                        )}
                      </span>
                      <span
                        style={{
                          fontSize: "12px",
                          color:
                            player.position === "goalie"
                              ? "#dc3545"
                              : "#6c757d",
                          fontWeight:
                            player.position === "goalie" ? "bold" : "normal",
                        }}
                      >
                        {player.position?.charAt(0).toUpperCase() +
                          player.position?.slice(1) || "Forward"}
                      </span>
                    </div>
                  );
                })
              ) : (
                <div style={{ color: "#6c757d", fontStyle: "italic" }}>
                  No players added
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Match Summary */}
        <div
          style={{
            backgroundColor: "white",
            padding: "clamp(15px, 4vw, 20px)",
            borderRadius: "8px",
            marginTop: "clamp(15px, 4vw, 20px)",
            boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          }}
        >
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            🏆 Match Summary
          </h4>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
              gap: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(12px, 2.5vw, 14px)",
            }}
          >
            <div>
              <strong>Winner:</strong>{" "}
              <span
                style={{
                  color:
                    match.winner === "team1"
                      ? "#27ae60"
                      : match.winner === "team2"
                      ? "#e74c3c"
                      : "#6c757d",
                  fontWeight: "bold",
                }}
              >
                {match.winner === "team1"
                  ? match.team1Name || "Team 1"
                  : match.winner === "team2"
                  ? match.team2Name || "Team 2"
                  : "Tie"}
              </span>
            </div>
            <div>
              <strong>Match Type:</strong> {match.matchType || "Regulation"}
            </div>
            <div>
              <strong>Final Score:</strong> {match.finalScore?.team1 || 0} -{" "}
              {match.finalScore?.team2 || 0}
            </div>
            <div>
              <strong>Total Goals:</strong> {match.goalEvents?.length || 0}
            </div>
            <div>
              <strong>Total Penalties:</strong>{" "}
              {match.penaltyEvents?.length || 0}
            </div>
            <div>
              <strong>Total Players:</strong>{" "}
              {(match.team1Players?.length || 0) +
                (match.team2Players?.length || 0)}
            </div>
          </div>
        </div>
      </div>
    );
  });
};

export default HockeyMatchDetails;
